import { defineAction } from '~/prix'
import userUpdateAction from './userUpdate.action.json' with { type: 'json' }
import { z } from 'zod'
import { enumerated } from '~/prix/types/enumerated'

const userUpdateDefinition = defineAction({
  ...userUpdateAction,

  input: z
    .object({
      id: z.string(),
      name: z.string(),
      email: z.string(),
      password: z.preprocess(
        value => (value === '' ? undefined : value),
        z.string().min(6, 'Senha deve ter pelo menos 6 caracteres').optional(),
      ),
      role: enumerated({
        systemAdministrator: 'Administrador do Sistema',
        generalAdministrator: 'Administrador Geral',
        generalProfessional: 'Profissional Geral',
        publicSafetyAdministrator: 'Administrador de Segurança Pública',
        publicSafetyAgent: 'Agente de Segurança Pública',
        healthAgent: 'Agente de Saúde',
        healthAdministrator: 'Administrador de Saúde',
        agricultureAdministrator: 'Administrador da Secretaria da Agricultura',
        agricultureProfessional: 'Profissional da Secretaria da Agricultura',
      }),
      deniedPermissionKeys: z.array(z.string()).optional(),
    })
    .passthrough(),
  output: z.object({
    message: z.string(),
    data: z.object({
      id: z.string(),
      name: z.string(),
      email: z.string(),
      role: z.string(),
      cpf: z.string().nullish(),
      isEmailVerified: z.boolean().nullish(),
      clientId: z.number(),
      cns: z.string().nullish(),
      createdAt: z.date(),
      updatedAt: z.date(),
      firebaseUpdated: z.boolean(),
      deniedPermissionKeys: z.array(z.string()).default([]),
    }),
  }),
})

export default userUpdateDefinition
